import React, { Component } from 'react';
import { Button, Col, Form, message, Row } from 'antd';
import { Link } from 'react-router';
import FlowSearch from '@comm/FlowSearch';
import '../expenses.less';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import { queryPaymentList } from '@api/finance/payment';
import TableExpenses from './TableExpenses';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
        loading: false,
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.route.path) {
      if (backInfo.start && backInfo.limit) {
        this.current = backInfo.start;
        this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        };
      }
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
      backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.route.path,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  setTableData = res => {
    if (res.statusCode === 200) {
      this.setState({
        dataSource: {
          list: res.data,
          pagination: {
            total: res.totalSize,
            pageSize: 15,
            current: this.current,
          },
        },
      });
    } else {
      message.error(res.message);
      this.setState({
        dataSource: {
          list: [],
          pagination: {
            total: 0,
            pageSize: 15,
            current: 1,
          },
        },
      });
    }
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getPaymentList = params => {
    this.setState({ loading: true });
    queryPaymentList(params).then(res => {
      this.setTableData(res);
      this.setState({ loading: false });
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getPaymentList(params);
  };

  render() {
    const { dataSource, loading } = this.state;
    const parentProps = {
      loading,
      dataSource,
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <Col span={5}>
            <Link to="/finance/p_manage/add">
              <Button type="primary">申请付款</Button>
            </Link>
          </Col>
          <Col span={19}>
            <FlowSearch onSearch={this.handleSearch} {...this.searchCondition} />
          </Col>
        </Row>
        <div id="ant-small-table">
          <TableExpenses {...parentProps} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/finance/payment/PageWatch.js